import { Inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {
  PlEntityCollectionService,
  PL_API_CONFIG,
  PlAPIConfig,
} from 'pl-core-services';
import { User } from '../models';

@Injectable()
export class PlUserService extends PlEntityCollectionService<User> {
  private readonly baseUrl: string;

  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    @Inject(PL_API_CONFIG) config: PlAPIConfig
  ) {
    super('User', serviceElementsFactory);
    this.baseUrl = `${config.kanga}/api/v1`;
  }
}
